import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";

export default class V1GetRestaurantCategories extends BaseOutgoingPayload {
  constructor() {
    super(OutgoingPayloadEvent.V1_GET_RESTAURANT_CATEGORIES);
  }
}
